import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

//Data
import popupDataBtn from "../../json/LoginScreen/button.json";

//Components
import NavbarComponent from "../../components/NavbarComponent/NavbarComponent";
import SideMenusComponent from "../../components/SideMenusComponent/SideMenusComponent";
import AttachDocBody from "../../components/AttachDocBody/AttachDocBody";
import LoadingScreenComponent from "../../components/LoadingScreenComponent/LoadingScreenComponent";
import NavbarMobile from "../../components/NavbarMobile/NavbarMobile";
import NavbarMobileBottom from "../../components/NavbarMobileBotton/NavbarMobileBottom";
import VersionTxtComponent from "../../components/VersionTxtComponent/VersionTxtComponent";
import PopUpComponent from "../../components/PopUpComponent/PopUpComponent";

//Context
import { LoadingContext } from "../../context/LoadingContext";
import { PopupContext } from "../../context/PopupContext";

const AttachDocScreen = ({ userData, userMenuData }) => {
  const { loading, hasComplementTxt } = useContext(LoadingContext);

  const { showPopup, popupData } = useContext(PopupContext);

  const history = useNavigate();

  const currentStep = localStorage.getItem("latestStep");

  switch (currentStep) {
    case "attach-document":
      history("/admin/crear-credito/adjuntar-poliza");
      break;
    case "attach-policy":
      history("/admin/crear-credito/adjuntar-anexo");
      break;
    case "attach-appendix":
      history("/admin/crear-credito/formulario");
      break;
    case "complement-data":
      history("/admin/crear-credito/formulario-confirmar");
      break;
    default:
      break;
  }

  return (
    <>
      {loading && (
        <LoadingScreenComponent hasComplementTxt={hasComplementTxt} />
      )}
      {showPopup && (
        <PopUpComponent content={popupData} btnData={popupDataBtn.data[0]} />
      )}
      <div className="body-container">
        <VersionTxtComponent />
        <div className="body-subcontainer">
          <NavbarComponent userData={userData} />
          <NavbarMobile userData={userData} menuData={userMenuData} />
          <AttachDocBody />
          <NavbarMobileBottom />
        </div>
        <SideMenusComponent menuData={userMenuData} />
      </div>
    </>
  );
};

export default AttachDocScreen;
